/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/common/table-data/table-data');

const store = require('appVuex/store');
const ajaxHttp = require('appUtil/ajaxHttp');
const tip = require('components/base/pop/tip');
const { time } = require('src/common/utils/date');
const { apiPath } = require('appService/api');

require('./integral-event-list.scss');
const template = require('./integral-event-list.tpl');

const IntegralEvent = {
	name: "integral-event-list",

	template,

	data() {
		return {
			thItems: ["序号", "事件名称", "分值", "每日次数上限", "状态", "操作"],
			url: apiPath.user.queryIntegral,
      disableMessage: '',
      disableIndex: '',
      disableItem: '',
      now: time(new Date().getTime()),
		}
	},

	ready() {

	},

	methods: {
		qurryIntegral() {
			let queryParams = {
        keyType: this.$refs.ktypeDropmenu.val(),
        keyWord: this.$refs.kwordInputbox.val()
      };
    	this.$refs.tableData.query(queryParams).fetch();
		},
		disableIntegral(index, item) {
			this.disableIndex = index;
      this.disableItem = item;
			this.$refs.disablePop.show();
			if( item === 1 ) {
				this.disableMessage = "确定启用该积分事件？"
			} else if( item === 0) {
				this.disableMessage = "确定停用该积分事件？"
			}
		},
		updateIntegralEvent() {
			let url  = apiPath.user.disableIntegral;
			let queryParams = {
				integralId: this.$refs.tableData.trItems[this.disableIndex].integralId,
				status: this.disableItem
			};
			ajaxHttp(url, {
				"type": "post",
				"data": queryParams
			}).then((res) => {
				this.$refs.disablePop.hide();
				this.$refs.tableData.trItems[this.disableIndex].state = res.data.state;
				if( this.disableItem === 1 ) {
					tip("已启用该积分事件！");
				} else if( this.disableItem === 0) {
					tip("已停用该积分事件！");
				}
			}).catch((res) => {
				tip(res.error);
			})
		}
	},

	store
}

module.exports = IntegralEvent;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/user/integral-event/integral-event-list.js